module.exports = __webpack_public_path__ + "static/future-wildlife-0e7f34e279d78af0006bee3ca5649d11.png";